var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPlusBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.32725 8.77153C4.32725 9.26245 4.72522 9.66042 5.21614 9.66042C5.70706 9.66042 6.10503 9.26245 6.10503 8.77153V5.88889H8.98778C9.4787 5.88889 9.87667 5.49092 9.87667 5C9.87667 4.50908 9.4787 4.11111 8.98778 4.11111H6.10503V1.22824C6.10503 0.737324 5.70706 0.339355 5.21614 0.339355C4.72522 0.339355 4.32725 0.737325 4.32725 1.22824V4.11111H1.44449C0.953571 4.11111 0.555603 4.50908 0.555603 5C0.555603 5.49092 0.953572 5.88889 1.44449 5.88889H4.32725V8.77153Z",
    fill: "#773DBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPlusBlue);
export default __webpack_public_path__ + "static/media/ic_plus_blue.303a8da5e171cb5e3316d79ccad154d1.svg";
export { ForwardRef as ReactComponent };